import { defineStore } from 'pinia';
// import state from './state';
// import getters from './getters';
// import actions from './actions';
// import mutations from './mutations';

export const useLayoutStore = defineStore('layout', {
  state: () => ({
    hideConfigButton: false,
    isPinned: true,
    showConfig: false,
    isRTL: false,
    color: '',
    sidebarType: 'bg-white',
    darkMode: false,
    isNavFixed: false,
    isAbsolute: false,
    showNavs: true,
    showSidenav: true,
    showNavbar: true,
    showFooter: true,
    showMain: true,
    isLoading: false,
    layout: 'default',
    query: {},
    progress: 0,
    isProgressBar: false,
    keepAlive: [],
    beforePath: ''
  }),
  actions: {
    toggleSidebarColor(sidebarType) {
      this.sidebarType = sidebarType;
    },
    toggleDefaultLayout() {
      console.log('toggleDefaultLayout');
      this.showNavbar = !this.showNavbar;
      this.showSidenav = !this.showSidenav;
      this.showFooter = !this.showFooter;
    },
    setLoginDefaultLayout() {
      console.log('setLoginDefaultLayout');
      this.showNavbar = false;
      this.showSidenav = false;
      this.showFooter = false;
    },
    setBeforePath(path = '') {
      this.beforePath = path;
    }
  },
  getters: {
    getIsRtl: (state) => state.isRTL,
    getIsNavFixed: (state) => state.isNavFixed,
    getDarkMode: (state) => state.darkMode
  },
  persist: true
});
